import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import styled, { useTheme } from "styled-components";
import TranslationContext from "../providers/TranslationContext";
import withComponentOverride from "../withComponentOverride";
const TypingContainer = withComponentOverride(styled.div `
	font-size: 11px;
	padding: 5px 7px 10px;
	background: ${(props) => {
    return props.theme.colors.typingStatusBg;
}};
	color: ${(props) => {
    return props.theme.colors.typingStatusColor;
}};
`);
const TypingIndicator = ({ isTyping }) => {
    const { components } = useTheme();
    const { typingText } = useContext(TranslationContext);
    return (_jsx(TypingContainer, { isTyping: isTyping, componentOverride: components?.TypingContainer, children: isTyping ? typingText : "\u00A0" }));
};
export default TypingIndicator;
